import { SvgIcon, SvgIconProps } from '@mui/material';

export const ChevronRight = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M9.47 5.47c.3-.3.77-.3 1.06 0l4.87 4.87.02.02c.18.18.35.35.48.5.13.16.27.35.35.6.11.35.11.73 0 1.08-.08.25-.22.44-.35.6-.13.15-.3.32-.48.5l-.02.02-4.87 4.87a.75.75 0 1 1-1.06-1.06l4.87-4.87a8.31 8.31 0 0 0 .48-.53.25.25 0 0 0 0-.14l-.07-.1-.4-.43-4.88-4.87a.75.75 0 0 1 0-1.06Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};
